import { Bell } from "@phosphor-icons/react";
import { ViewerMenu } from "@/components/layout/ViewerMenu";
import { IconButton } from "./IconButton";

/**
 * Default minimal header controls — notifications + the viewer's account control.
 * Same treatment as the marketplace utility header's icons (MarketplaceUtilityHeader),
 * minus the marketplace-specific search/Upload/cart controls.
 */
export function HeaderUtilities() {
  return (
    <>
      <IconButton
        label="Notifications"
        size="md"
        className="!h-10 !w-10 !rounded-full !bg-transparent hover:!bg-surface-3"
        icon={<Bell size={20} weight="regular" />}
      />
      <ViewerMenu />
    </>
  );
}
